<mat-form-field
  [class.light-form-field]="lightFormField"
  data-cy="user-multiselect">
  <mat-label class="select-label-with-badge">
    <span>{{
      label || ("creator" | i18n) || "Ersteller" | titlecase
    }}</span>
    <span
      *ngIf="selectedCount > 0"
      class="selection-count-badge"
      data-cy="selection-count-badge">
      {{ selectedCount }}
    </span>
  </mat-label>
  <mat-select
    [ngModel]="selectedCreators"
    (ngModelChange)="onSelectionChange($event)"
    (openedChange)="onSelectOpenedChange($event)"
    [disabled]="disabled"
    multiple
    data-cy="user-multiselect-input">
    <mat-option
      disabled
      class="mat-select-search-option">
      <input
        matInput
        #selectSearchInput
        [placeholder]="('search' | i18n) || 'search' | titlecase"
        [ngModel]="selectSearchTerm$ | async"
        (ngModelChange)="selectSearchTerm$.next($event)"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
        data-cy="user-multiselect-search-input" />
    </mat-option>
    <mat-option
      [value]="'ALL'"
      data-cy="creator-option-all">
      {{ ("all" | i18n) || "Alle" }}
    </mat-option>
    <mat-divider></mat-divider>
    <ng-container *ngIf="filteredCreatorUsers$ | async as filteredCreatorUsers">
      <mat-option
        *ngFor="let user of filteredCreatorUsers; trackBy: trackByUserId"
        [value]="user._id"
        [attr.data-cy]="'creator-option-' + user._id">
        {{ user.firstName }} {{ user.lastName }}
      </mat-option>
    </ng-container>
  </mat-select>
</mat-form-field>
